import styled from '@emotion/styled';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiIconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';

import { typography } from '$variables/theme';
import COLORS from '$variables/colors';

export const Header = styled(MuiDialogTitle)`
  padding: 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  background-color: ${COLORS.white};
`;

export const Title = styled.div`
  color: ${COLORS.default};
  font-size: 16px;
  font-weight: ${typography.fontWeightMedium};
  margin-left: 24px;

  flex-grow: 1;
  text-align: center;
`;

export const SubTitle = styled.div`
  color: ${COLORS.grey3};
  font-size: 12px;
  line-height: 18px;

  text-align: center;
  margin-top: 4px;
`;

export const DialogContent = styled(MuiDialogContent)`
  padding: 0;
`;

export const DialogActions = styled(MuiDialogActions, {
  shouldForwardProp: (prop) =>
    prop !== 'hasFooterDecoration' && prop !== 'compactFooter',
})`
  display: flex;
  align-items: center;
  justify-content: ${({ hasFooterDecoration }) =>
    hasFooterDecoration ? 'space-between' : 'flex-end'};
  margin: 12px;
  padding: 0;
`;

export const IconButton = styled(MuiIconButton)`
  padding: 0;
  color: ${COLORS.grey5};
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${COLORS.grey};
`;

export const Loader = styled(CircularProgress)`
  padding: 4px 16px;
  color: ${COLORS.green};
`;
